"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultColumnTypes = void 0;
var columns_1 = require("./columns");
var service_1 = require("../../service");
exports.DefaultColumnTypes = (_a = {},
    _a[columns_1.DefaultColumnName.CmhcLoanAccountNumber] = service_1.SqlType.INT,
    _a[columns_1.DefaultColumnName.LastRecordUpdatedTimestamp] = service_1.SqlType.DATETIME2,
    _a[columns_1.DefaultColumnName.RequestReceivedTimestamp] = service_1.SqlType.DATETIME2,
    _a);
